module.exports = __webpack_public_path__ + "img/number3.90e56a03.jpg";